import React from 'react';

interface ButtonProps {
  className: string;
  id: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  children?: React.ReactNode;
  style?: React.CSSProperties;
  disabled?: boolean;
}

export function Button(props: ButtonProps) {
  // Sanitise the button properties to avoid warnings
  const buttonProps = {
    className: props.className,
    id: props.id,
    onClick: props.onClick,
    type: props.type,
    style: props.style,
    disabled: props.disabled,
  };
  return (
    <button {...buttonProps} className={`${props.className}`}>
      {props.children}
    </button>
  );
}
